import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-yields-icon',
  templateUrl: './yields-icon.component.html',
  styles: []
})
export class YieldsIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
